import { useEffect, useState } from "react";
import {
  Save,
  User,
  Mail,
  Phone,
  Calendar,
} from "lucide-react";

import ProfilePageLayout from "../../components/profile/ProfilePageLayout";

export default function EditProfile() {

  const [form, setForm] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    username: "",
  });

  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    try {
      const auth = JSON.parse(localStorage.getItem("auth"));
      const storedUser =
        auth?.user ||
        auth?.profile ||
        auth?.data?.user ||
        JSON.parse(localStorage.getItem("user")) ||
        {};

      setForm({
        first_name: storedUser.first_name || "",
        last_name: storedUser.last_name || "",
        email: storedUser.email || "",
        phone: storedUser.phone || "",
        username: storedUser.username || "",
      });

    } catch (error) {
      console.error("Error cargando información:", error);
    }
  }, []);

  const handleChange = (event) => {
    const { name, value } = event.target;

    setForm((previous) => ({
      ...previous,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    setSaving(true);
    setMessage("");

    /*
      Aquí posteriormente conectamos:

      API.put("/users/profile/", form)

      cuando tengamos confirmado tu endpoint Django.
    */

    setTimeout(() => {
      setSaving(false);
      setMessage("Cambios guardados correctamente.");

      localStorage.setItem(
        "user",
        JSON.stringify(form)
      );
    }, 700);
  };

  return (
    <ProfilePageLayout
      title="Información personal"
      subtitle="Administra los datos asociados a tu cuenta."
      icon={User}
    >

      <div className="profile-form-grid">

        <section className="profile-template-card">

          <div className="profile-card-title">
            <User size={20} />
            <div>
              <h2>Datos personales</h2>
              <p>Información básica de tu cuenta</p>
            </div>
          </div>

          <form onSubmit={handleSubmit}>

            <div className="profile-input-row">

              <label>
                Nombre
                <div className="profile-input-wrapper">
                  <User size={17} />

                  <input
                    type="text"
                    name="first_name"
                    value={form.first_name}
                    onChange={handleChange}
                    placeholder="Tu nombre"
                  />
                </div>
              </label>

              <label>
                Apellido
                <div className="profile-input-wrapper">
                  <User size={17} />

                  <input
                    type="text"
                    name="last_name"
                    value={form.last_name}
                    onChange={handleChange}
                    placeholder="Tu apellido"
                  />
                </div>
              </label>

            </div>

            <label>
              Correo electrónico

              <div className="profile-input-wrapper">
                <Mail size={17} />

                <input
                  type="email"
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                  placeholder="correo@ejemplo.com"
                />
              </div>
            </label>

            <label>
              Teléfono

              <div className="profile-input-wrapper">
                <Phone size={17} />

                <input
                  type="tel"
                  name="phone"
                  value={form.phone}
                  onChange={handleChange}
                  placeholder="+57 300 000 0000"
                />
              </div>
            </label>

            <label>
              Nombre de usuario

              <div className="profile-input-wrapper">
                <User size={17} />

                <input
                  type="text"
                  name="username"
                  value={form.username}
                  onChange={handleChange}
                  placeholder="usuario"
                />
              </div>
            </label>

            {message && (
              <div className="profile-success-message">
                {message}
              </div>
            )}

            <button
              type="submit"
              className="profile-neon-button"
              disabled={saving}
            >
              <Save size={18} />

              {saving
                ? "GUARDANDO..."
                : "GUARDAR CAMBIOS"}
            </button>

          </form>

        </section>

        <aside className="profile-template-card profile-info-card">

          <div className="profile-card-title">
            <Calendar size={20} />

            <div>
              <h2>Tu cuenta</h2>
              <p>Información de registro</p>
            </div>
          </div>

          <div className="profile-info-list">

            <div>
              <span>Estado</span>
              <strong className="profile-status">
                ACTIVA
              </strong>
            </div>

            <div>
              <span>Tipo de cuenta</span>
              <strong>CLIENTE</strong>
            </div>

            <div>
              <span>Miembro</span>
              <strong>DEBUTS CROP</strong>
            </div>

          </div>

        </aside>

      </div>

    </ProfilePageLayout>
  );
}